import React from 'react';
import { Button as MuiButton, type ButtonProps as MuiButtonProps } from '@mui/material';

export interface ActionButtonProps extends Omit<MuiButtonProps, 'variant'> {
    width?: string | number;
}

const ActionButton: React.FC<ActionButtonProps> = ({ children, width, sx, ...props }) => {
    return (
        <MuiButton
            variant='contained'
            {...props}
            sx={{
                backgroundColor: '#0A1D56',
                px: 4,
                py: 1.5,
                borderRadius: '12px',
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': {
                    backgroundColor: '#091B4C',
                },
                ...sx,
            }}
        >
            {children}
        </MuiButton>
    );
};

export default ActionButton;
